import React from 'react';
import Modal from './components/Modal';

const ImpressumModal = ({ isOpen, onClose }) => {
  const sectionTitleStyle = {
    color: '#666666',
    fontFamily: 'Sora, sans-serif',
    fontSize: '1.25rem',
    fontWeight: '500',
    marginTop: '2rem',
    marginBottom: '1rem',
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Impressum" maxWidth="800px">
      <div>
        <p>Angaben gemäß § 5 TMG:</p>
        <p>
          Physiotherapiezentrum Uwe Veronik<br />
          Leopoldstrasse 18<br />
          80802 München<br />
          Vertreten durch: Herrn Uwe Veronik
        </p>

        <h3 style={sectionTitleStyle}>Kontakt</h3>
        <p>
          Telefon: 089-34077791<br />
          Telefax: 089-34077792<br />
          E-Mail: info@uweveronik.de
        </p>

        <p>
          <strong>Gesetzliche Berufsbezeichnung</strong><br />
          Physiotherapeut und Masseur und medizinischer Bademeister, verliehen in der Bundesrepublik Deutschland
        </p>

        <h3 style={sectionTitleStyle}>Zuständige Aufsichtsbehörde</h3>
        <p>Gesundheitsamt München</p>

        <h3 style={sectionTitleStyle}>Berufshaftpflichtversicherung</h3>
        <p>Generali Versicherungen Nr. 2-23.770.484-9</p>

        <h3 style={sectionTitleStyle}>Haftungsausschluss</h3>
        
        <h4 style={{...sectionTitleStyle, fontSize: '1.1rem', marginTop: '1.5rem'}}>Haftung für Inhalte</h4>
        <p>
          Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
        </p>

        <h4 style={{...sectionTitleStyle, fontSize: '1.1rem', marginTop: '1.5rem'}}>Haftung für Links</h4>
        <p>
          Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
        </p>

        <h4 style={{...sectionTitleStyle, fontSize: '1.1rem', marginTop: '1.5rem'}}>Urheberrecht</h4>
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
        </p>
      </div>
    </Modal>
  );
};

export default ImpressumModal; 